import StatementOfAccounts from "./StatementOfAccounts";

const StatementOfAccountsConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/statement-of-account',
            element: <StatementOfAccounts />,
        },
    ],
}

export default StatementOfAccountsConfig;